module.exports = "/public/images/29960fcc2e5ff11bb166a2cf9958b578.png";